import React from 'react';
import PropTypes from 'prop-types';
import { StyledDataList, StyledOption } from './styled';

const InputDataList = ({ id, datalist }) => {
    return (
        <StyledDataList
            id={id}
        >
            {datalist && datalist.map(option => (
                <StyledOption key={option.id} id={option.id}>
                    {option.name}
                </StyledOption>
            ))}
        </StyledDataList>
    );
};

InputDataList.propTypes = {
    id: PropTypes.string,
    datalist: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string
        })
    ),
};

InputDataList.defaultProps = {
    datalist: []
};

export default React.memo(InputDataList);
